import { motion } from 'framer-motion';
import styled from 'styled-components';

import {
    PROFILE_WIDTH_LAPTOP,
    PROFILE_WIDTH_DESKTOP,
    GRID_GUTTER_MOBILE,
    GRID_GUTTER_LAPTOP,
    GRID_GUTTER_DESKTOP,
} from '../config';

export const GridWrapper = styled(motion.div)`
    width: 100%;
    padding: ${GRID_GUTTER_MOBILE}px ${GRID_GUTTER_MOBILE}px 100px;

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
        padding: ${GRID_GUTTER_LAPTOP}px ${GRID_GUTTER_LAPTOP}px 0 ${PROFILE_WIDTH_LAPTOP}px;
        margin-left: -${PROFILE_WIDTH_LAPTOP}px;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        padding: ${GRID_GUTTER_DESKTOP}px ${GRID_GUTTER_DESKTOP}px 0 ${PROFILE_WIDTH_DESKTOP}px;
        margin-left: -${PROFILE_WIDTH_DESKTOP}px;
    }
`;

export const LoadMoreWrapper = styled.div`
    display: flex;
    justify-content: center;
    padding-bottom: 20px;
`;
